import ComplaintsService from "@/api/services/complaints";
import { toCamelCase } from "@estaly/ui";

const initialState = {
  index: [],
};

export default {
  namespaced: true,
  state: initialState,
  getters: {
    getIndex(state) {
      return state.index;
    },
    isClosed: () => (complaint) => {
      return complaint?.status === "closed";
    },
    statusStyle: () => (status) => {
      const map = {
        open: "bg-yellow-100 text-yellow-800",
        in_review: "bg-blue-100 text-blue-800",
        closed: "bg-green-100 text-green-800",
      };
      return map[status] ?? "bg-gray-100 text-gray-800";
    },
    statuses: () => () => {
      return ["open", "in_review", "closed"];
    },
    createdBy: () => () => {
      return ["estaly", "customer"];
    },
    responseNatures: () => () => {
      return ["favorable", "partially_favorable", "unfavorable"];
    },
    channels: () => () => {
      return ["email", "letter", "social_media", "other"];
    },
    themes: () => () => {
      return ["production", "claim"];
    },
    subthemes: () => () => {
      return ["pricing", "acknowledgement", "contract_management", "indemnization", "termination", "other"];
    },
  },
  mutations: {
    setIndex(state, data) {
      state.index = data.complaints;
      state.currentPage = data.page.currentPage || 1;
      state.totalPages = data.page.totalPages || 0;
      state.totalCount = data.page.totalCount || 0;
    },
  },
  actions: {
    async fetchIndex({ commit }, { page } = {}) {
      const response = await ComplaintsService.fetchIndex({ page });
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      commit("setIndex", data);
      return data;
    },

    async fetch(_, { id, ...params }) {
      const response = await ComplaintsService.fetch(id, params);
      if (!response?.success) return;

      return toCamelCase(response.data);
    },

    async update(_, { id, data }) {
      const response = await ComplaintsService.update(id, data);
      if (!response?.success) return;

      return response;
    },

    async create(_, { data }) {
      const response = await ComplaintsService.create(data);
      if (!response?.success) return;

      return response;
    },
  },
};
